import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Public pages
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import JoinTeam from "@/pages/JoinTeam";

// Protected pages
import DashboardLayout from "@/components/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import MonthlyEntry from "@/pages/MonthlyEntry";
import DataImport from "@/pages/DataImport";
import DataStatus from "@/pages/DataStatus";
import MySchedule from "@/pages/MySchedule";
import Reports from "@/pages/Reports";
import YearComparison from "@/pages/YearComparison";
import Settings from "@/pages/Settings";
import CommitteeView from "@/pages/CommitteeView";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Documents from "@/pages/Documents";
import DocumentEditor from "@/pages/DocumentEditor";

// Auth check
const isAuthenticated = () => {
  const user = localStorage.getItem("user");
  return !!user;
};

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Public route wrapper (redirect to dashboard if logged in)
const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<PublicRoute><Landing /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          <Route path="/join/:token" element={<JoinTeam />} />
          
          {/* Protected routes */}
          <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="monthly-entry" element={<MonthlyEntry />} />
            <Route path="data-status" element={<DataStatus />} />
            <Route path="my-schedule" element={<MySchedule />} />
            <Route path="import" element={<DataImport />} />
            <Route path="reports" element={<Reports />} />
            <Route path="year-comparison" element={<YearComparison />} />
            <Route path="committee" element={<CommitteeView />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:projectId" element={<ProjectDetail />} />
            <Route path="documents" element={<Documents />} />
            <Route path="documents/:docId" element={<DocumentEditor />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
